export default "__VITE_ASSET__ev8wBEl9__$_?inline__"